import { api } from "@/api";
import { AxiosResponse } from "axios";
import { PayloadNotificationListType } from "../types";
class API {
  static getIsNotification(): Promise<AxiosResponse> {
    return api.get("/notification/it4cio/verify");
  }
  static getNotificationWasSeen(params: number): Promise<AxiosResponse> {
    return api.get(`/notification/update/${params}`);
  }
  static getNotificationList(
    payload: PayloadNotificationListType
  ): Promise<AxiosResponse> {
    return api.get("/notification/it4cio", { params: payload });
  }
  static putNotificationConfigure(payload: any): Promise<AxiosResponse> {
    return api.put("/notification/it4cio/configuration", payload);
  }
  static getNotificationConfig(): Promise<AxiosResponse> {
    return api.get("/notification/it4cio/configuration");
  }
  static getIsMessageNotification(): Promise<AxiosResponse> {
    return api.get("/notification/message-verify");
  }
  static patchNotificationRead(payload: number): Promise<AxiosResponse> {
    return api.patch(`/notification/it4cio/${payload}/read`);
  }
  static patchNotificationUnread(payload: number): Promise<AxiosResponse> {
    return api.patch(`/notification/it4cio/${payload}/not-read`);
  }
  static deleteNotification(payload: number): Promise<AxiosResponse> {
    return api.delete(`/notification/it4cio/${payload}`);
  }
  static patchNotificationAllRead(): Promise<AxiosResponse> {
    return api.patch(`/notification/it4cio/all/read`);
  }
}

export default API;
